var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size,"tile":_vm.tile}},[_c('v-img',{attrs:{"src":_vm.src,"lazy-src":_vm.src,"alt":_vm.alt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }